
{
  "title": "提交新列表",
  "description": "创建新的服务列表以吸引客户",
  "alerts": {
    "reviewRequired": "您的列表将在上线前进行审核。"
  },
  "languageNote": "注意：所有列表应使用英文或繁体中文，以便香港用户更好地查看。"
}
